import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../views/Layout.vue'
import RealtStatus from '../views/RealtStatus.vue'
import Login from "@/views/Login";
import ErrorRecords from '@/views/ErrorRecords'
import ConfigManage from '@/views/ConfigManage'
import RealErrorPage from '@/views/RealErrorPage'
import SendEmailRecords from "@/views/SendEmailRecords";
import NodeManage from "@/views/NodeManage";
import SensorError from '@/views/SensorError'
import OffLineStatus from '../views/OffLineStatus.vue'
import NoWavePicture from '../views/NoWavePicture.vue'
import CheckDiary from '../views/CheckDiary.vue'
import UserManage from "@/views/UserManage";
import {ElMessage} from "element-plus/lib/components";
import ConfigPrivilege from "@/views/ConfigPrivilege";
import OverView from "@/views/OverView";
const routes = [
  {
    path: '/',
    redirect: '/Login', // 将首页重定向到登录页面
  },
  {
    path: '/Login',
    name: Login,
    component: Login
  },
  {
    path: '/RealErrorPage',
    name: 'RealErrorPage',

    component: Layout,
    children: [
      {
        path: '/RealErrorPage',
        name: 'RealErrorPage',
        redirect: '/OffLineStatus',
        component: RealErrorPage,
        children: [
          {
            path: '/OverView',
            name: 'OverView',
            component: OverView
          },
          {
            path: '/OffLineStatus',
            name: 'OffLineStatus',
            component: OffLineStatus
          },
          {
            path: '/RealtStatus',
            name: 'RealtStatus',
            component: RealtStatus
          },
          {
            path: '/ErrorRecords',
            name: 'ErrorRecords',
            component: ErrorRecords
          },
          {
            path: '/SensorError',
            name: 'SensorError',
            component: SensorError
          },
          {
            path: '/ConfigPrivilege',
            name: ConfigPrivilege,
            component: ConfigPrivilege
          }
        ]
      },
      {
        path: '/ConfigManage',
        name: 'ConfigManage',
        component: ConfigManage
      },
      {
        path: '/SendEmailRecords',
        name: 'SendEmailRecords',
        component: SendEmailRecords
      },
      {
        path: '/NodeManage',
        name: 'NodeManage',
        component: NodeManage
      },
      {
        path: '/NoWavePicture',
        hidden: true,
        component: NoWavePicture,
        name: 'NoWavePicture',
      },
      {
        path: '/CheckDiary',
        name: 'CheckDiary',
        component: CheckDiary
      },
      {
        path: '/UserManage',
        name: 'UserManage',
        component: UserManage
      },

      // 登录路由
      {
        path: '/Login',
        name: 'Login',
        component: Login // 请确保有一个名为Login的组件
      },
    ]
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 添加登录状态判断和跳转逻辑

router.beforeEach((to,from,next)=>{



  if (localStorage.getItem("username") !='' && localStorage.getItem("username")!=null  || to.path == '/Login'  )
  {

    next()


  }
  else {
    next('/Login')
    ElMessage.error("请先登录")
    console.log("用户未登录")
  }
})

export default router;
